const validate = (input, validators) => {
  let invalid = Object.keys(input).filter((key) => {
    let value = input[key]
    return !value || validators[key]?.(value)
  })

  return invalid
}
const validators = {
  phone: (value) => {
    return value.replaceAll(/[^\d]/g, '').length !== 10
  },
  email: (value) => {
    return !/^\S+@\S+\.\S+$/.test(value)
  },
}
export { validate, validators }
